<template>
    <v-card  height="100%" width="100%" hover @click="$emit('click')">
        <v-container v-if="assetList != null">
            <v-img contain
            :src="(assetList.thmUrl != null) ? assetList.thmUrl : 'https://activstoredev.blob.core.windows.net/test/box.png'"  
            style="height:160px;width:100%">
            </v-img>
            <v-card-text>
                <div class="subtitle-1">{{assetList.name}}</div>
            </v-card-text>
        </v-container>
    </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: "AssetListCard",
    props: {
      //Assetlist model for this card
      assetList:
      {
          default : null,
          type : Object
      }, 
    },
    computed:{

       
    },
    data: () => ({
        
    }),
    methods:{
       
    }
}
</script> 

<style>

</style>